export const getRegionName = (regionCode: string) => {
  const regionNamesInEnglish = new Intl.DisplayNames(["en"], { type: "region" });
  try {
    return regionNamesInEnglish.of(regionCode);
  } catch (error) {
    return regionCode;
  }
};
